import {Component, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {smoothEnterLeaveAnimation} from '../../../shared/animations/custom-animations';
import {RegistrationService} from '../../services/registration.service';
import {Router} from '@angular/router';
import {DomainNameParserService} from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';
import {PHONE_NUMBER_LIST} from 'src/main/resources/static/angular2/app/shared/constants/phone-numbers.const';

@Component({
  selector: 'app-confirm-email-page',
  templateUrl: './confirm-email-page.component.html',
  styleUrls: ['./confirm-email-page.component.css'],
  animations: [
    trigger('openSuccessAlert', smoothEnterLeaveAnimation('100ms 150ms', '100ms')),
    trigger('openUpdatedEmailSuccessAlert', smoothEnterLeaveAnimation('100ms 150ms', '100ms')),
    trigger('showReenterEmailWindow', [
      state('shown', style({
        opacity: 1,
        height: '*'
      })),
      state('hidden', style({
        opacity: 0,
        height: 0,
        overflow: 'hidden'
      })),
      transition('hidden => shown', [
        animate('100ms ease-in-out')
      ])
    ]),
  ]
})
export class ConfirmEmailPageComponent implements OnInit {

  resendEmailAlertShown = false;
  username: string;
  customerServicePhone: string;

  constructor(private regService: RegistrationService,
              private router: Router,
              private domainNameParserService: DomainNameParserService) {
    this.username = this.router.getCurrentNavigation().extras.state.username;
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
  }

  ngOnInit(): void {
  }

  public resendVerificationEmail(): void {
    if(this.username == null || this.username == undefined) {
      console.error('No username detected. Did not resend email verification link. Please register again.');
      return;
    }

    console.log('Resending verification email to: ', this.username);
    this.regService.sendEmailLink(this.username).subscribe(_ => {},
      error => {
        console.error('ServiceLayer returned error. Details: ' + JSON.stringify(error));
      });

    this.resendEmailAlertShown = true;
  }

}
